<template>
  <div>
    <el-table
      :data="authors.data"
      :default-sort="{ prop: order_column, order: order_type }"
      @sort-change="sort"      
      class="w100"
      stripe
    >  
      <el-table-column label="Author" prop="name" sortable></el-table-column>
      <el-table-column label="Company" prop="company" sortable></el-table-column>
      <el-table-column label="Create date" prop="created_at" sortable>
        <template slot-scope="props">
          {{ props.row.created_at | date }}
        </template>
      </el-table-column>
      <el-table-column label="Actions" align="right" width="200%">
          <template slot-scope="props">                                   
            <el-tooltip content="Edit" placement="top">
              <el-button
                type="warning"
                circle
                size="small"
                icon="el-icon-edit"
                @click="openEdit(props.row)"
              ></el-button>
            </el-tooltip>
            <el-tooltip content="Delete" placement="top">
              <el-button
                type="danger"
                circle
                size="small"
                icon="el-icon-close"
                @click="deleteA(props.row.id)"
              ></el-button>
            </el-tooltip>            
          </template>
        </el-table-column>                                 
    </el-table>
    <el-pagination
      class="float-right"
      background
      @size-change="sizeChange"
      @current-change="currentChange"
      :current-page.sync="authors.current_page"
      :page-sizes="[5, 10, 25, 50, 100]"
      :page-size="page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="authors.total"
    ></el-pagination>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  computed: {
    ...mapState('blogAuthor', [
      'authors',
      'page',
      'page_size',
      'order_column',
      'order_type'      
    ])
  },

  methods: {
    ...mapActions('blogAuthor', [
      'read',
      'delete'
    ]),
    ...mapMutations('blogAuthor', [
      'setPage', 
      'setPageSize', 
      'setOrdering',
      'setDialog',
      'setSelectedAuthor'
    ]),

    sizeChange(page_size) {
      this.setPageSize(page_size)
      this.read()
    },
    currentChange(page) {
      this.setPage(page)
      this.read()
    },
    sort(d) {
      this.setOrdering({
        column: d.prop,
        type: this.ascDesc(d.order)
      })
      this.read()
    },
    openEdit(author) {
      this.setDialog(true)
      this.setSelectedAuthor(author)
    },
    deleteA(id) {
      this.$confirm(
        'You will permanently delete this author. Continue?',
        'Warning',
        {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }
      )
        .then(() => {
          this.delete(id)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: 'Delete cancelled'
          })
        })
    },

  },

  created() {
    this.read()
  }
}
</script>